import { createContext, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
const SEOContext = createContext();

export const SEOProvider = ({ children }) => {
  const { t } = useTranslation();
  const [seo, setSeo] = useState({
    title: "Mükemel ® Touch Of Soul",
    description: t("home.meta.description"),
    keywords: t("home.meta.keywords"),
    favicon: "/faviconnew.png",
    ogImage:
      "https://mukemel.com/static/media/brothers.c791973cd1c46d462816.webp",
    ogUrl: typeof window !== "undefined" ? window.location.href : "",
    ogType: "Web",
    siteName: "Touch Of Soul",
  });

  useEffect(() => {
    document.title = seo.title;

    const setMeta = (name, content, property = false) => {
      if (!content) return;
      const selector = property
        ? `meta[property="${name}"]`
        : `meta[name="${name}"]`;

      let element = document.querySelector(selector);
      if (!element) {
        element = document.createElement("meta");
        if (property) {
          element.setAttribute("property", name);
        } else {
          element.setAttribute("name", name);
        }
        document.head.appendChild(element);
      }
      element.setAttribute("content", content);
    };

    setMeta("description", seo.description);
    setMeta("keywords", seo.keywords);

    // 🆕 OG etiketleri
    setMeta("og:title", seo.title, true);
    setMeta("og:description", seo.description, true);
    setMeta("og:image", seo.ogImage, true);
    setMeta("og:url", seo.ogUrl, true);
    setMeta("og:type", seo.ogType, true);
    setMeta("og:site_name", seo.siteName || "Touch Of Soul", true);

    // 🐦 Twitter kartı (isteğe bağlı)
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", seo.title);
    setMeta("twitter:description", seo.description);
    setMeta("twitter:image", seo.ogImage);

    // Favicon
    if (seo.favicon) {
      const existingFavicon = document.querySelector("link[rel='icon']");
      if (existingFavicon) {
        existingFavicon.setAttribute("href", seo.favicon);
      } else {
        const link = document.createElement("link");
        link.rel = "icon";
        link.href = seo.favicon;
        document.head.appendChild(link);
      }
    }
    // ✅ CANONICAL
    if (seo.ogUrl) {
      let canonicalLink = document.querySelector("link[rel='canonical']");
      if (!canonicalLink) {
        canonicalLink = document.createElement("link");
        canonicalLink.setAttribute("rel", "canonical");
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.setAttribute("href", seo.ogUrl);
    }
  }, [seo]);

  return <SEOContext.Provider value={setSeo}>{children}</SEOContext.Provider>;
};

export const useSEO = () => useContext(SEOContext);
